var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4796 2.63303C10.4796 2.29763 10.0916 2.11116 9.82972 2.32068L5.76773 5.57027C5.69681 5.62701 5.60868 5.65792 5.51786 5.65792H2.40103C2.06965 5.65792 1.80103 5.92655 1.80103 6.25792V10.8436C1.80103 11.175 2.06965 11.4436 2.40103 11.4436H5.51786C5.60868 11.4436 5.69681 11.4745 5.76773 11.5313L9.82972 14.7809C10.0916 14.9904 10.4796 14.8039 10.4796 14.4685V2.63303Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8574 5.13867C15.7613 6.04282 16.2691 7.26895 16.2691 8.54742C16.2691 9.82589 15.7613 11.052 14.8574 11.9562",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSound);
export default __webpack_public_path__ + "static/media/ic_sound.95c5502d08c4401c62abfaad2b7bfbd8.svg";
export { ForwardRef as ReactComponent };